import { render, staticRenderFns } from "./ChatbotSelect.vue?vue&type=template&id=20e3fc95&scoped=true"
import script from "./ChatbotSelect.vue?vue&type=script&lang=js"
export * from "./ChatbotSelect.vue?vue&type=script&lang=js"
import style0 from "./ChatbotSelect.vue?vue&type=style&index=0&id=20e3fc95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3fc95",
  null
  
)

export default component.exports